module.exports = __webpack_public_path__ + "static/media/download_icon_disabled.9e379f57.svg";